import { IBitfCloseEvent } from '@app/interfaces';
import { map } from 'rxjs/operators';
export function toEventData() {
  return map((event: IBitfCloseEvent<any>) => {
    return (event || { data: undefined }).data;
  });
}
